"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREAKPOINT_XXL = exports.BREAKPOINT_XS = exports.BREAKPOINT_XL = exports.BREAKPOINT_SM = exports.BREAKPOINT_MD = exports.BREAKPOINT_LG = void 0;
exports.default = useResponsiveBreakpoint;

require("core-js/modules/es.array.find-index");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

var _react = require("react");

var _useResponsiveDimension = _interopRequireDefault(require("./useResponsiveDimension"));

var BREAKPOINT_XS = 'xs';
exports.BREAKPOINT_XS = BREAKPOINT_XS;
var BREAKPOINT_SM = 'sm';
exports.BREAKPOINT_SM = BREAKPOINT_SM;
var BREAKPOINT_MD = 'md';
exports.BREAKPOINT_MD = BREAKPOINT_MD;
var BREAKPOINT_LG = 'lg';
exports.BREAKPOINT_LG = BREAKPOINT_LG;
var BREAKPOINT_XL = 'xl';
exports.BREAKPOINT_XL = BREAKPOINT_XL;
var BREAKPOINT_XXL = 'xxl';
/**
 * Receives a breakpoint with a screen size like xs, sm, md, lg, xl, xxl,
 * returns true when the window screen is below or equal that breakpoint.
 * @param bp
 * @returns {boolean}
 */

exports.BREAKPOINT_XXL = BREAKPOINT_XXL;

function useResponsiveBreakpoint(bp) {
  var dm = (0, _useResponsiveDimension.default)();
  var brArray = [BREAKPOINT_XS, BREAKPOINT_SM, BREAKPOINT_MD, BREAKPOINT_LG, BREAKPOINT_XL, BREAKPOINT_XXL];
  var index = brArray.findIndex(function (v) {
    return v === bp;
  });
  var slice = brArray.slice(0, index + 1);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      broken = _useState2[0],
      setBroken = _useState2[1];

  (0, _react.useEffect)(function () {
    if (index === -1) {
      setBroken(false);
    } else {
      setBroken(slice.includes(dm));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [dm]);
  return broken;
}